import type { Id } from '@hq/utils';
import { toQuery, type HttpClient } from '../client';
import type { MaterialListQuery, MaterialRow } from '../types/material';
import type { PageResult } from '../types/result';

const BASE = '/wl/material';

/** 物资主数据（只读）。 */
export function createMaterialApi(http: HttpClient) {
  return {
    list(query: MaterialListQuery = {}): Promise<PageResult<MaterialRow>> {
      return http.request<PageResult<MaterialRow>>({ path: BASE, query: toQuery(query) });
    },

    detail(id: Id): Promise<MaterialRow> {
      return http.request<MaterialRow>({ path: `${BASE}/${id}` });
    }
  };
}

export type MaterialApi = ReturnType<typeof createMaterialApi>;
